import React, { useEffect } from 'react';
import { startDateModStyles } from './StartDateMod.styles';
import { Controller, useFormContext, useWatch } from 'react-hook-form';
import moment from 'moment';
import { Grid, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { selectCurrentModDetails } from 'store/redux-store/placement-mods/selectors';

export const NewEndDate = () => {
  const { classes } = startDateModStyles();
  const { control, getValues, setValue } = useFormContext();
  const value: any = useWatch({ name: 'newEndDate' });
  const keepConstant: any = useWatch({ name: 'keepConstant' });
  const selectedModsDetails = useSelector(selectCurrentModDetails);
  const { t } = useTranslation();

  useEffect(() => {
    let newEndDate = '--';
    const newStartDate = getValues('newStartDate');
    if (
      (keepConstant === 'true' || keepConstant === true) &&
      newStartDate &&
      selectedModsDetails?.currentStartDate &&
      selectedModsDetails?.currentEndDate
    ) {
      const currentStart = moment(selectedModsDetails?.currentStartDate);
      const newStart = moment(newStartDate);
      const end = moment(selectedModsDetails?.currentEndDate);
      if (currentStart && newStart && end) {
        const diff = newStart.diff(currentStart);
        newEndDate = moment(selectedModsDetails?.currentEndDate).add(diff)?.format('MM/DD/YYYY');
      }
    }
    setValue('newEndDate', newEndDate);
  }, [keepConstant, getValues('newStartDate')]);
  return (
    <Controller
      control={control}
      name={'newEndDate'}
      render={({ field: { onChange, ...rest } }) => {
        return (
          <Grid className={classes.labelRow}>
            <Typography component="span" className={classes.labelFont}>{`${t(
              'placement.placementMods.newEndDate',
            )}`}</Typography>
            <Typography component="span">{value}</Typography>
          </Grid>
        );
      }}
    />
  );
};
